import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

const OldEmailSubmit = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0e12] text-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full bg-gray-900 border border-gray-800 rounded-2xl p-8 text-center shadow-2xl">

        <h1
          className="text-2xl sm:text-3xl font-bold mb-6
                     bg-gradient-to-r from-red-400 via-orange-400 to-red-400
                     bg-clip-text text-transparent"
        >
          Submissions Closed
        </h1>

        <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-8">
          Thank you for your submission. The <span className="text-white font-medium">Udbhav 2.0</span> submission window
          is now closed. We appreciate your interest and wish you all the best for
          <span className="text-white font-medium"> Udbhav 3.0</span>.
        </p>
{/* 
        <Button
          disabled
          className="bg-gray-700 cursor-not-allowed px-8 py-2 rounded-xl opacity-70"
        >
          Submissions Closed
        </Button> */}

      </div>
    </div>
  );
};

export default OldEmailSubmit;
